var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.frames.length > 0)?_c('div',{class:[
    // Position
    'absolute',
    'z-edit-post',

    !_setup.isLoadingPortraitMobileLayout && [
      // Desktop position
      'top-1/2 -translate-y-2/4',
      // Size
      'w-[100px]',
      // Shape
      'rounded-e-3xl',
      _setup.surfaceWindowMobileNotchStore.isApplyingSafeAreaInsetStart ? 'rounded-3xl' : 'rounded-s-none',
    ],
    _setup.isLoadingPortraitMobileLayout && [
      // Mobile position
      'top-0 start-1/2 -translate-x-2/4',
      // Shape
      'rounded-2xl',
      // Size
      'max-w-[calc(100%-1.5rem)]',
    ],

    // Color
    {
      'bg-popover-dark': _setup.colorScheme === 'dark',
      'bg-popover-light': _setup.colorScheme === 'light',
      'backdrop-blur-10': true,
    },

    // Children positioning
    'justify-center',
  ],style:({
    insetInlineStart: !_setup.isLoadingPortraitMobileLayout
      ? _setup.surfaceWindowMobileNotchStore.safeAreaInsetStart + 'px'
      : '50%',
  })},[_c('div',{ref:"containerRef",class:[
      'relative',
      // Shape
      'max-h-full',
      !_setup.isLoadingPortraitMobileLayout && [
        // Children paddings
        'py-3 ps-3 pe-4',
        // Size
        'box-border', // So that the calculation on the next line is correct
        'w-[114px]', //  100px content + 14px scrollbar
        // Children positioning
        'flex flex-col',
        // Gap
        'gap-y-3',
        'overflow-y-auto overflow-x-hidden',
      ],
      _setup.isLoadingPortraitMobileLayout && [
        // Children paddings
        'py-0 ps-2 pe-0.5',
        // Size
        'box-border', // So that the calculation on the next line is correct
        'h-[100px]',
        'max-w-full',
        // Children positioning
        'flex flex-row',
        // Gap
        'gap-x-1',
      ],
      'transition-all',
      'items-start',
      {
        'scrollbar-photo-dark-on-hover': _setup.colorScheme === 'dark' && _setup.height > _setup.props.maxHeight,
        'scrollbar-photo-on-hover': _setup.colorScheme === 'light' && _setup.height > _setup.props.maxHeight,
        'scrollbar-photo-transparent': _setup.height <= _setup.props.maxHeight,
      },
      'scrollbar-gutter-stable',
    ],style:(!_setup.isLoadingPortraitMobileLayout
        ? {
            maxHeight: _setup.props.maxHeight + 'px',
            minHeight: _setup.props.minHeight + 'px',
            height: _setup.height + 'px',
          }
        : {})},[(_setup.whiteboardPermissionsStore.canIManage)?_c('div',{class:{ 'h-full box-border py-2': _setup.isLoadingPortraitMobileLayout }},[_c(_setup.OzBaseButton,{ref:"buttonRef",class:[
          // Shape
          {
            'w-18 h-6': !_setup.isLoadingPortraitMobileLayout,
            'w-10 h-full': _setup.isLoadingPortraitMobileLayout,
          },
          'box-border',
          'rounded-lg',
          'shrink-0',
          // Don't use disabled property because we still want pointer events to trigger the tooltip
          _setup.whiteboardStore.hasReachedPlanFrameLimitAndCannotUpgrade && '!cursor-not-allowed',

          // Color
          _setup.colorScheme === 'dark'
            ? [
                'ring-light-text-200',
                'bg-button-dark',
                'hhover:bg-button-hover-dark',
                'hactive:ring-3',
                'hactive:ring-light-text-100',
                'hactive:bg-dark-text-100',
                'hfocus-visible:ring-3',
                'hfocus-visible:ring-canary-500',
                'hfocus-visible:bg-modal-overlay-canary/20',
              ]
            : '',
          _setup.colorScheme === 'light'
            ? [
                'ring-dark-text-200',
                'bg-button-light',
                'hhover:bg-button-hover-light',
                'hactive:ring-dark-text-100',
                'hactive:ring-3',
                'hactive:bg-light-text-100',
                'hfocus-visible:ring-3',
                'hfocus-visible:ring-grape-500',
                'hfocus-visible:bg-modal-overlay-grape/20',
              ]
            : '',

          // Transition
          'transition-all',
          'duration-150',
          'ease-in-out',

          // Children positioning
          'flex',
          'items-center',
          'justify-center',

          // Children styling
          'text-body-small',
          'font-semibold',
          {
            'text-light-text-100': _setup.colorScheme === 'dark',
            'text-dark-text-100': _setup.colorScheme === 'light',
          },
        ],attrs:{"size-preset":undefined,"color-scheme":undefined,"dark-mode":_setup.colorScheme === 'dark',"label":_setup.helperText},on:{"pointerenter":_setup.handleButtonHover,"pointerleave":_setup.handleButtonLeave,"click":_setup.addFrame}},[_c(_setup.OzIcon,{attrs:{"font":"oricon","name":'plus_thick',"size":16}})],1)],1):_vm._e(),_vm._v(" "),_c('div',{class:!_setup.isLoadingPortraitMobileLayout
          ? ['contents']
          : ['flex', 'overflow-x-auto overflow-y-hidden', 'gap-x-1.5', 'h-full pt-2 ps-3 pe-2 box-border']},_vm._l((_setup.frames),function(frame,index){return _c(_setup.WhiteboardFramePreview,{key:frame.id,ref:"frameList",refInFor:true,attrs:{"frame-id":frame.id,"frame-index":index + 1,"current-frame-id":_setup.currentFrameId,"color-scheme":_setup.colorScheme,"is-loading-portrait-mobile-layout":_setup.isLoadingPortraitMobileLayout,"preview-html":_setup.framePreviews[frame.id],"is-draggable":_setup.whiteboardPermissionsStore.canIEdit},on:{"switch-frame":_setup.switchFrame,"show-context-menu":_setup.showContextMenu,"move-frame-above":_setup.whiteboardStore.moveFrameAbove,"move-frame-below":_setup.whiteboardStore.moveFrameBelow}})}),1)]),_vm._v(" "),_c('Transition',{attrs:{"enter-active-class":"transition-opacity duration-250 ease-out motion-reduce:transition-none","leave-active-class":"transition-opacity duration-150 ease-in motion-reduce:transition-none","enter-class":"opacity-0","leave-to-class":"opacity-0","appear":""}},[(_setup.xTooltip && _setup.buttonEl)?_c(_setup.OzBasePopover,{class:[
        'px-3 py-1',
        'pointer-events-none',
        {
          'bg-common-ui-d70 ': _setup.colorScheme === 'dark',
          'bg-common-ui-l86': _setup.colorScheme === 'light',
        },
        'backdrop-blur-6',
        'w-max',
      ],attrs:{"config":{
        middleware: [
          _setup.offset(16),
          _setup.autoPlacement({
            allowedPlacements: ['top', 'top-start', 'top-end'],
          }),
        ],
      },"role":"tooltip","anchor":_setup.buttonEl,"radius":8,"color":_setup.OzBasePopoverColors.None}},[_c('span',{class:_setup.colorScheme === 'dark' ? 'text-light-text-100' : 'text-dark-text-100'},[_vm._v(_vm._s(_setup.helperText))])]):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }